const FLOATING_POINT_REGEX = /^[Ee0-9+\-.]$/;
/**
 * Determine if a character is a DOM floating point character
 * @see https://www.w3.org/TR/2012/WD-html-markup-20120329/datatypes.html#common.data.float
 */
const isFloatingPointNumericCharacter = (character: string) => {
  return FLOATING_POINT_REGEX.test(character);
};

/**
 * First alternative:
 *  Targets floating point values (22.55, 10.1, 22.)
 * Second alternative:
 *  Targets whole numbers
 */
const VALID_PRICE_REGEX = /^((\d*\.{1}?(?!\.)\d*)|(\d*))/g;

// 22.01234512566661233444.55
// 525.22
// 22..0.55
const extractValidPrice = (val: string) => {
  const maybeMatch = val.match(VALID_PRICE_REGEX);
  return maybeMatch?.[0] || val;
};

export const formatPriceInputValue = (val: string) => `$${val}`;

export const sanitizeAndExtractPriceValue = (value: string) => {
  const sanitizedValue = value.split('').filter(isFloatingPointNumericCharacter).join('');
  return extractValidPrice(sanitizedValue);
};
